"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  name: 'DetailReportTable',
  data: function data() {var _this = this;
    return {
      tableData: [],
      isShow: false,
      addData: {
        downMonitorNum: '',
        downDataParser: '',
        isConvert: 'false',
        isSubjoin: 'false' },

      tableColumns: [
      {
        prop: 'startByte',
        label: '开始所在字节(从0开始)',
        isShow: true },

      {
        prop: 'startBit',
        label: '开始bit',
        isShow: true,
        render: function render(h, params) {
          return h('Input', {
            props: {
              value: params.row.colCnName },

            domProps: {
              title: params.row['colCnName'] },

            on: {
              'on-blur': function onBlur(event) {
                _this.fieldDetailList1[params.index].colCnName =
                event.target.value;
              } } });


        } },

      {
        prop: 'bitLength',
        label: 'bit长度',
        isShow: true }],


      rules: {} };


  },
  mounted: function mounted() {
    // const self = this
    // self.handleGetData()
  },
  methods: {
    handleGetData: function handleGetData(data) {
      this.tableData = data;
      // this.tableData.push({ 'startByte': 1, 'startBit': 1, 'bitLength': 10 })
      // this.tableData.push({ 'startByte': 2, 'startBit': 3, 'bitLength': 10 })
    },
    handleAdd: function handleAdd() {
      this.tableData.push({ 'startByte': '', 'startBit': '', 'bitLength': '' });
    },
    handleDel: function handleDel(index) {
      this.tableData.splice(index, 1);
    },
    handleChangeSubjoin: function handleChangeSubjoin() {
      if (this.addData.isSubjoin === 'true') {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    handleChangeConvert: function handleChangeConvert() {
    } } };exports.default = _default;